import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { Box, IconButton, Typography, Drawer, useTheme, Divider } from '@mui/material';

interface Props {
  title?: string;
  subtitle?: string;
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  customAdditionalHeaderComponent?: React.ReactNode;
  customTitle?: React.ReactNode;
  customSubtitle?: React.ReactNode;
  customStyle?: React.CSSProperties;
}

const Sidebar = (props: Props) => {
  const {
    isOpen,
    onClose,
    children,
    title,
    subtitle,
    customAdditionalHeaderComponent,
    customSubtitle,
    customTitle,
  } = props;

  const theme = useTheme();

  const handleOnClose = () => {
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  return (
    <Drawer
      anchor="right"
      open={isOpen}
      onClose={handleOnClose}
      sx={{
        '& .MuiPaper-root': {
          backgroundColor: 'colors.white',
          overflow: 'hidden',
        },
      }}
      PaperProps={{
        sx: {
          width: '100%',
          maxWidth: '460px',
          height: '100%',
          overflowY: 'auto',
        },
      }}
    >
      <Box>
        <Box
          sx={{
            padding: '8px 0px 0px 16px',
          }}
        >
          <IconButton onClick={handleOnClose}>
            <KeyboardDoubleArrowRightIcon />
          </IconButton>
        </Box>
        {
          <Box>
            {customAdditionalHeaderComponent}

            {customTitle || (
              <Typography
                variant={subtitle ? 'h4' : 'h3'}
                paddingLeft={3}
                marginBottom={subtitle || customSubtitle ? 1 : 4}
                maxWidth={400}
              >
                {title}
              </Typography>
            )}

            {subtitle && (
              <>
                <Typography
                  variant="h6"
                  paddingLeft={3}
                  maxWidth={400}
                  color={theme.palette.colors.lightGrey}
                >
                  {subtitle}
                </Typography>
                <Divider sx={{ mt: 1 }} />
              </>
            )}
            {customSubtitle}
          </Box>
        }
        {children}
      </Box>
    </Drawer>
  );
};

export default Sidebar;
